import { log } from 'log';
import { prop } from 'ramda';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { resetToDefault } from '@core/js/hooks/user/store/actions';
import { useUserSelector } from '@core/js/store/hooks';
import { htcmdService } from '@core/js/services/htcmd.service';
import { removeCookie } from '@core/js/utils/cookie.util';

import * as pas from '@core/js/hooks/auth/pas';
import * as actions from '@core/js/hooks/auth/store/actions';
import * as helpers from '@core/js/hooks/auth/helpers';

export const COOKIE_NAME = 'clientType';

export const useLogout = () => {
    const dispatch = useDispatch();
    const sessionToken = useUserSelector(prop('sessionToken'));

    return useCallback(async ({ isQuiet = false, isManual = true } = {}) => {
        dispatch(actions.setIsLogoutManual(isManual));
        dispatch(actions.setIsLogoutInProcess(true));
        dispatch(resetToDefault());

        helpers.removeRememberMeItem();

        try {
            await pas.setLoginType(null);

            if (!isQuiet || sessionToken) {
                // do a regular logout to clear everything, all sessions
                // sessionToken check is needed to do logout in a separate tab
                let params = {};

                if (htcmdService.isEnabledAndTemporary) {
                    params = {
                        allSessions: 0,
                        logoutBehavior: 'hierarchical'
                    };
                }

                await pas.logout(params);
            }
        } catch (err) {
            log('info', err);
        } finally {
            removeCookie(COOKIE_NAME);
            dispatch(actions.setIsLogoutInProcess(false));
        }
    }, [
        dispatch,
        sessionToken
    ]);
};
